import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type { LeadsSelectedColumnsRequestDto } from "app/pages/sales-intelligence/modules/leads-search";
import { selectActiveLeadsType, leadsSearchQueryKeys } from "app/pages/sales-intelligence/modules/leads-search";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { listsQueryKeys } from "../key-factory/factory";

type HookParams = Pick<UseMutationOptions<void, unknown, LeadsSelectedColumnsRequestDto>, "onSuccess">;

export const useColumnSelectionMutation = ({ onSuccess }: HookParams = {}) => {
    const queryClient = useQueryClient();
    const activeLeadsType = useSelector(selectActiveLeadsType);

    return useMutation({
        mutationFn(dto: LeadsSelectedColumnsRequestDto) {
            return salesApiService.listColumns.saveColumnSelection(dto, activeLeadsType);
        },
        onSuccess(data, dto, context) {
            onSuccess?.(data, dto, context);

            void queryClient.invalidateQueries({
                queryKey: listsQueryKeys.columnSelection(),
            });

            void queryClient.resetQueries({
                queryKey: leadsSearchQueryKeys.tableData(),
            });
        },
    });
};
